import { createApi } from '@reduxjs/toolkit/query/react';
import type { BaseQueryFn } from '@reduxjs/toolkit/query/react';
import type { AxiosError, Method } from 'axios';
import axiosInstance, { getBaseURL, type ServiceType } from './instance';

export type BaseQueryProps = {
  url: string;
  method: Extract<Method, 'post' | 'get' | 'put' | 'patch' | 'delete'>;
  data?: any; // AxiosRequestConfig['data'];
  params?: any; // AxiosRequestConfig['params'];
  headers?: Record<string, string>;
  timeout?: number;
  service?: ServiceType; // Allow specifying different service base URLs
};

export type BaseQuery = BaseQueryFn<BaseQueryProps, unknown, unknown>;

const baseQuery: BaseQuery = async (args) => {
  const { method, url, headers, timeout, service = 'crm', data, params } = args;

  try {
    const response = await axiosInstance({
      baseURL: getBaseURL(service),
      url,
      method,
      params,
      data,
      headers,
      timeout,
    });
    // 204 No Content: no JSON body — treat as success with a stable payload for mutations/queries
    if (response.status === 204) {
      return { data: { success: true } };
    }
    return { data: response.data };
  } catch (error) {
    const err = error as AxiosError;
    return {
      error: {
        status: err.response?.status || 'AXIOS_ERROR',
        data: err.response?.data || err.message,
      },
    };
  }
};

export const apiBase = createApi({
  reducerPath: 'api',
  baseQuery,
  endpoints: () => ({}),
  tagTypes: ['Campaign', 'Package', 'ChopeDinerTags'],
  refetchOnMountOrArgChange: true,
});
